var map = {
	"./img_1.jpg": 88942,
	"./img_2.jpg": 90353,
	"./img_3.jpg": 82258,
	"./img_4.jpg": 46235,
	"./img_5.jpg": 70651,
	"./img_6.png": 57907
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20746;